module.exports = __webpack_public_path__ + "static/media/8.0867a6e1.mp3";